(function($){
    $(".header-nav__list-item_has-secondary .header-nav__link").click(function(e) {
        // console.log(this);
        // if ($(this).hasClass("is-open")) {
        //     $(this).removeClass("is-open");
        // } else {
        //     $(".header-nav__list-item_has-secondary").removeClass("is-open");
        //     $(this).addClass("is-open");
        // }
        // console.log($(this).parent());
        $(this).parent().toggleClass("is-open");
    });
})(jQuery);


// WEBPACK FOOTER //
// ./common.blocks/header-nav/header-nav.js